import { Fragment } from "react";

import Skeleton from "common/components/ui/Skeleton";

interface ConversationLoaderProps {
  itemsCount?: number;
}

export default function ConversationLoader({
  itemsCount = 1,
}: ConversationLoaderProps) {
  const getLoaderList = (count: number) =>
    Array(count)
      .fill(0)
      .map((_, index) => index);

  return (
    <div className="flex flex-col">
      {getLoaderList(itemsCount).map((item) => (
        <Fragment key={item}>
          <div className="flex flex-col gap-2 p-3 lg:px-4 border-b border-b-black-200 first:border-t first:border-t-black-200">
            <div className="flex flex-row items-center gap-x-1.5">
              <Skeleton className="size-8 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </div>
            <Skeleton className="h-4 w-3/4" />

            <div className="flex flex-row items-center justify-between">
              <Skeleton className="h-5 w-20 rounded-full" />
              <Skeleton className="h-4 w-10" />
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
